const FIM_RICH_TEXT_SELECTOR = '[data-fim-richtext]';
const FIM_PROGRESS_SELECTOR = '[data-fim-progress]';
const FIM_KEY_IMAGE_SELECTOR = [
  '.fim-story-split__media img',
  '.fim-page-hero__media-card img',
  '.fim-tutorial-card__image',
  '.fim-support-card__image',
  '.fim-feature-card__image',
].join(',');
const FIM_STABLE_SHASHIBO_IMAGE =
  'https://cdn.shopify.com/s/files/1/0523/7738/7168/files/shashibo-Recovered-RecoveredArtboard-1-copy-61_3_41650249-f513-4da3-be8f-58014c797d44.png?v=1760019395';
const FIM_POLICY_LINK_REWRITES = new Map([
  ['/policies/refund-policy', '/pages/refund-policy'],
  ['/policies/shipping-policy', '/pages/shipping-policy'],
  ['/policies/privacy-policy', '/pages/privacy-policy'],
  ['/policies/terms-of-service', '/pages/terms-of-service'],
]);
const BAD_TEXT_RULES = [
  [/\\u0431\\u043a/g, ' - '],
  [/\\u00a0/g, ' '],
  [/Related support routes/g, 'More ways to get help'],
  [/Use the contact route if you need order help or product support\./g, 'Contact us when you need order help or product support.'],
  [/Keep the collection footer tied to real routes instead of generic policy clutter\./g, 'Keep exploring with tutorials, bundles, and helpful answers before your next play session.'],
  [/This official collection shell hands the shopper into a bundle build, a shop feed, and helpful how-to paths\./g, 'Build your bundle, browse every Shashibo design, and find helpful how-to guides.'],
  [/Match the same tutorial bridge the official category uses\./g, 'Learn new shapes and keep the play moving.'],
  [/Route buyers into the FAQ without leaving the store domain\./g, 'Find answers about gifting, shipping, and how to get more from every toy.'],
  [/real category shell/g, 'category guide'],
  [/direct bridges/g, 'quick links'],
  [/official collection shell/g, 'collection guide'],
  [/support handoff/g, 'support guide'],
  [/handoff/g, 'guide'],
  [/store domain/g, 'store'],
  [/generic policy clutter/g, 'extra clutter'],
];

function sanitizeTextNode(node) {
  let nextValue = node.nodeValue;
  BAD_TEXT_RULES.forEach(([pattern, replacement]) => {
    nextValue = nextValue.replace(pattern, replacement);
  });
  if (nextValue !== node.nodeValue) {
    node.nodeValue = nextValue;
  }
}

function sanitizeRichText(root) {
  const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
  let node = walker.nextNode();
  while (node) {
    sanitizeTextNode(node);
    node = walker.nextNode();
  }
}

function sanitizeRichTextRoots() {
  document.querySelectorAll(FIM_RICH_TEXT_SELECTOR).forEach((root) => sanitizeRichText(root));
}

function sanitizePolicyLinks(root = document) {
  root.querySelectorAll('a[href]').forEach((link) => {
    const rawHref = link.getAttribute('href');
    if (!rawHref) return;

    let url;
    try {
      url = new URL(rawHref, window.location.origin);
    } catch (error) {
      return;
    }

    const replacement = FIM_POLICY_LINK_REWRITES.get(url.pathname);
    if (!replacement) return;

    url.pathname = replacement;
    link.setAttribute('href', url.origin === window.location.origin ? `${url.pathname}${url.search}${url.hash}` : url.href);
  });
}

function updateProgressElements() {
  const viewportHeight = window.innerHeight || 1;
  document.querySelectorAll(FIM_PROGRESS_SELECTOR).forEach((element) => {
    const rect = element.getBoundingClientRect();
    const start = viewportHeight;
    const end = -rect.height;
    const rawProgress = (start - rect.top) / (start - end || 1);
    const progress = Math.max(0, Math.min(1, rawProgress));
    element.style.setProperty('--fim-progress', progress.toFixed(4));
  });
}

function bindScrollTargets() {
  document.querySelectorAll('[data-fim-scroll-target]').forEach((button) => {
    if (button.dataset.fimScrollBound === 'true') return;
    button.dataset.fimScrollBound = 'true';
    button.addEventListener('click', (event) => {
      const selector = button.getAttribute('data-fim-scroll-target');
      if (!selector) return;
      const target = document.querySelector(selector);
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });
}

function bindSavingsMedia() {
  document.querySelectorAll('[data-fim-savings-media]').forEach((root) => {
    if (root.dataset.fimSavingsBound === 'true') return;
    root.dataset.fimSavingsBound = 'true';

    const video = root.querySelector('video');
    const toggle = root.querySelector('[data-fim-savings-toggle]');
    if (!video || !toggle) return;

    const syncReady = () => {
      root.classList.toggle('is-ready', video.readyState >= 2);
    };

    const syncState = () => {
      const paused = video.paused;
      root.classList.toggle('is-paused', paused);
      toggle.setAttribute('aria-pressed', paused ? 'false' : 'true');
      toggle.setAttribute('aria-label', paused ? 'Play savings video' : 'Pause savings video');
      syncReady();
    };

    toggle.addEventListener('click', () => {
      if (video.paused) {
        video.play().catch(() => {});
      } else {
        video.pause();
      }
      syncState();
    });

    video.addEventListener('play', syncState);
    video.addEventListener('pause', syncState);
    video.addEventListener('loadeddata', syncReady);
    video.addEventListener('canplay', syncReady);
    video.addEventListener('playing', syncReady);
    syncReady();
    syncState();
  });
}

function refreshKeyImages() {
  document.querySelectorAll(FIM_KEY_IMAGE_SELECTOR).forEach((image) => {
    const rawSrc = image.getAttribute('src') || '';
    const isTutorialOrSupport = image.closest('.fim-tutorial-card, .fim-support-card');

    if (isTutorialOrSupport && rawSrc.includes('ShashiboimagefixArtboard1copy19')) {
      image.setAttribute('src', FIM_STABLE_SHASHIBO_IMAGE);
    }

    image.setAttribute('loading', 'eager');
    image.setAttribute('decoding', 'async');

    if (!image.complete || image.naturalWidth === 0) {
      const currentSrc = image.getAttribute('src');
      if (currentSrc) {
        image.setAttribute('src', currentSrc);
      }
    }
  });
}

function bootFunInMotionTheme() {
  sanitizePolicyLinks();
  sanitizeRichTextRoots();
  refreshKeyImages();
  updateProgressElements();
  bindScrollTargets();
  bindSavingsMedia();
}

let ticking = false;

function requestProgressUpdate() {
  if (ticking) return;
  ticking = true;
  window.requestAnimationFrame(() => {
    updateProgressElements();
    ticking = false;
  });
}

document.addEventListener('DOMContentLoaded', bootFunInMotionTheme, { once: true });
document.addEventListener('shopify:section:load', bootFunInMotionTheme);
window.addEventListener('load', refreshKeyImages, { once: true });
window.addEventListener('scroll', requestProgressUpdate, { passive: true });
window.addEventListener('resize', requestProgressUpdate);
